import { useQuery } from "@tanstack/react-query";
import { getRoles } from "../../api/apiRoles";
import i18next from "i18next";

export function useGetRole(id) {

    const {
        isLoading,
        data: Role,
        error,
    } = useQuery({
        queryKey: ["roles", id, i18next.language],
        queryFn: () => getRoles(id),
        retry: false,
    });

    return { isLoading, error, Role };
}
